import React from 'react';
import { PropTypes } from 'prop-types';
import { FaTimes } from 'react-icons/fa';
import Button from '../../Button/Button';

const SiteTagsDisplay = ({
  assignedTags, handleOpenDeleteModal,
}) => {
  return (
    <div className="mb-3 flex flex-row">
      {assignedTags?.map((tag) => (
        <Button key={tag.id} color="tertiary" label={tag.name} onClick={(e) => handleOpenDeleteModal(e, tag.id, tag.name)} size="md" Icon={<FaTimes className="fa fa-2xs" />} iconPosition="back" />
      ))}
    </div>
  );
};

SiteTagsDisplay.propTypes = {
  assignedTags: PropTypes.array.isRequired,
  handleOpenDeleteModal: PropTypes.func.isRequired,
};

export default SiteTagsDisplay;
